import { jsx as _jsx } from "react/jsx-runtime";
import devNote from '@xingternal/dev-note';
import { XingFrameContext, useFeatureSwitches, useFeatures, useIsBrowserBarOpen, useNotifications, useNotificationsHandler, useViewerData, } from '@xingternal/hub';
export const FrameDataModule = ({ children, internalPaths, pollInterval, ...props }) => {
    var _a;
    const { data: features = {} } = useFeatures();
    const { data: featureSwitches = [] } = useFeatureSwitches();
    const viewerData = useViewerData();
    const { hashedUserId, user, loginState, willingnessToChangeJobs = 0, networkEfficiencyIndicator, } = (_a = viewerData.data) !== null && _a !== void 0 ? _a : {};
    const notifications = useNotifications();
    const notificationsHandler = useNotificationsHandler();
    const isBrowserBarOpen = useIsBrowserBarOpen();
    const context = {
        browserBarOpen: !isBrowserBarOpen,
        willingnessToChangeJobs,
        cookies: {},
        features,
        featureSwitches,
        hashedUserId: hashedUserId || '',
        hasUser: Object.keys(user || {}).length > 0,
        internalPaths,
        pollInterval,
        loadingAppStatsQuery: false,
        loadingMainQuery: viewerData.loading,
        loggedOut: loginState === 'LOGGED_OUT',
        loginState: loginState !== null && loginState !== void 0 ? loginState : 'SOFT_LOGGED_IN',
        networkEfficiencyIndicator,
        notifications,
        refreshNotifications: notificationsHandler.refresh,
        user: {
            ...user,
            ...{
                get unscrambledId() {
                    var _a;
                    // This removes the scrambled part (`.abc123`) of the ID
                    return Number.parseInt((_a = user === null || user === void 0 ? void 0 : user.id) !== null && _a !== void 0 ? _a : '0', 10);
                },
            },
            // If user.occupationOrg or user.occupationTitle is used
            profileOccupation: {
                get occupationOrg() {
                    var _a, _b, _c;
                    devNote.warn('occupationOrg is deprecated. Please use `user.occupations[0].headline`.');
                    return (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.occupations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.headline) !== null && _c !== void 0 ? _c : '';
                },
                get occupationTitle() {
                    var _a, _b, _c;
                    devNote.warn('occupationTitle is deprecated. Please use `user.occupations[0].subline`.');
                    return (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.occupations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.subline) !== null && _c !== void 0 ? _c : '';
                },
            },
        },
        ...props,
    };
    return (_jsx(XingFrameContext.Provider, { value: context, children: children }));
};
//# sourceMappingURL=frame-data-module.js.map